import { PollingManager } from "./pollingManager";
import type { Event, OrderEvent } from "./types";
import { take } from "./api";

export const takePollingManager = new PollingManager<Event | OrderEvent>({ timeout: 5000 }, take);
